import { supabase } from '../config/supabase';

export const clientService = {
  // Get all clients for current user
  getUserClients: async (userId) => {
    const { data, error } = await supabase
      .from('cashflow_clients_a7b9c3d2e1')
      .select(`
        *,
        cashflow_commissions_a7b9c3d2e1 (*)
      `)
      .eq('user_id', userId)
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    
    // Format the data to match the app's expected structure
    return data.map(client => ({
      id: client.id,
      contactName: client.contact_name,
      clientName: client.client_name,
      contractValue: client.contract_value,
      status: client.status,
      createdAt: new Date(client.created_at),
      notes: client.notes,
      commission: client.cashflow_commissions_a7b9c3d2e1.length > 0 
        ? client.cashflow_commissions_a7b9c3d2e1[0].amount 
        : null,
      userId: client.user_id
    }));
  },
  
  // Get all clients (admin only)
  getAllClients: async () => {
    const { data, error } = await supabase
      .from('cashflow_clients_a7b9c3d2e1')
      .select(`
        *,
        cashflow_users_a7b9c3d2e1 (name, email),
        cashflow_commissions_a7b9c3d2e1 (*)
      `)
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    
    // Format the data to match the app's expected structure
    return data.map(client => ({
      id: client.id,
      contactName: client.contact_name,
      clientName: client.client_name,
      contractValue: client.contract_value,
      status: client.status,
      createdAt: new Date(client.created_at),
      notes: client.notes,
      commission: client.cashflow_commissions_a7b9c3d2e1.length > 0 
        ? client.cashflow_commissions_a7b9c3d2e1[0].amount 
        : null,
      userId: client.user_id,
      userName: client.cashflow_users_a7b9c3d2e1?.name || 'Unknown'
    }));
  },
  
  // Add a new client
  addClient: async (clientData) => {
    const { data, error } = await supabase
      .from('cashflow_clients_a7b9c3d2e1')
      .insert([{
        contact_name: clientData.contactName,
        client_name: clientData.clientName,
        contract_value: clientData.contractValue,
        notes: clientData.notes,
        user_id: clientData.userId
      }])
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Update client status
  updateClientStatus: async (clientId, status) => {
    const { data, error } = await supabase
      .from('cashflow_clients_a7b9c3d2e1')
      .update({ status })
      .eq('id', clientId)
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Delete a client
  deleteClient: async (clientId) => {
    const { error } = await supabase
      .from('cashflow_clients_a7b9c3d2e1')
      .delete()
      .eq('id', clientId);
    
    if (error) throw error;
    return true;
  },
  
  // Add commission to a client
  addCommission: async (clientId, amount, percentage = null) => {
    // Begin a transaction: add commission record and update client status
    const { data: commissionData, error: commissionError } = await supabase
      .from('cashflow_commissions_a7b9c3d2e1')
      .insert([{
        client_id: clientId,
        amount,
        percentage
      }])
      .select();
    
    if (commissionError) throw commissionError;
    
    // Update client status to commissionato
    const { error: statusError } = await supabase
      .from('cashflow_clients_a7b9c3d2e1')
      .update({ status: 'commissionato' })
      .eq('id', clientId);
    
    if (statusError) throw statusError;
    
    return commissionData[0];
  }
};